import { render, staticRenderFns } from "./RiskGradingControl.vue?vue&type=template&id=fe55e9d4&scoped=true"
import script from "./RiskGradingControl.vue?vue&type=script&lang=js"
export * from "./RiskGradingControl.vue?vue&type=script&lang=js"
import style0 from "./RiskGradingControl.vue?vue&type=style&index=0&id=fe55e9d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe55e9d4",
  null
  
)

export default component.exports